module.exports = __webpack_public_path__ + "img/botuo1.6ef63e9d.png";